import { Injectable } from '@angular/core';
import { TimeZoneConfig } from './types';

@Injectable({ providedIn: 'root' })
export class TimeZoneConfigService {
  private config: TimeZoneConfig;

  constructor() {}

  init(config: TimeZoneConfig): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.config = config;
      resolve(true);
    });
  }

  get(): TimeZoneConfig {
    return this.config;
  }
}
